export enum DEPARTMENT {
    SALES = 'sales',
    SERVICE = 'service',
    PARTS = 'parts',
}
